const initEventSingle = () => {
  document.querySelectorAll('[data-event-image-modal]').forEach((modal) => {
    const root = modal.closest('.event-single')
    const openButton = root ? root.querySelector('[data-event-image-open]') : null
    const modalImage = modal.querySelector('[data-event-image-modal-image]')
    const closeButtons = Array.from(modal.querySelectorAll('[data-event-image-close]'))

    if (!openButton || !modalImage) {
      return
    }

    const openModal = () => {
      const imageSrc = openButton.getAttribute('data-image-modal') || ''
      const imageAlt = openButton.getAttribute('data-image-alt') || ''

      modalImage.src = imageSrc
      modalImage.alt = imageAlt
      modal.hidden = false
      document.body.classList.add('has-gallery-modal')
    }

    const closeModal = () => {
      modal.hidden = true
      document.body.classList.remove('has-gallery-modal')
    }

    openButton.addEventListener('click', openModal)
    closeButtons.forEach((button) => {
      button.addEventListener('click', closeModal)
    })

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal()
      }
    })
  })
}

export default initEventSingle



// WEBPACK FOOTER //
// ./resources/assets/js/components/event-single.js